export default class TotalHelper {
    getTotal(rows) {
        return Object.values(rows).reduce((a, b) => a + b, 0)
    }
}